export default () => {
    if (typeof window !== "undefined") {
        const {pathname} = window.location;
        const isDetailsPage = new RegExp(/(\/buy-used-[a-zA-Z0-9-]*-car-[0-9]*)/).test(pathname);
        return isDetailsPage;
    }
    return false;
};
